<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white">
                Dashboard </router-link>
            <router-link to="/admin/eduschool/eduschool-exam-prep">
                <span class="text-white"><i class="fa fa-ellipsis-v"></i> Exam </span></router-link>
            <router-link to="/admin/eduschool/eduschool-exam-prep/subject">
                <span class="text-white"><i class="fa fa-ellipsis-v"></i> Subject </span></router-link>
            <span class="text-white"><i class="fa fa-ellipsis-v"></i> Question </span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">

            <div class="mb-5 mb-xl-0">
                <card header-classes="bg-transparent">
                    <div class="card border-0 mb-0">
                        <div class="card-body">
                            <list-skeleton v-if="!SubjectItems" :rows="3" />
                            <div v-else class="card">
                                <div class="card-body bg-secondary">
                                    <h3>Subject : <b>{{ SubjectItems.examSubject }}</b></h3>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-body">
                                    <modal :show.sync="modals.questionModal"
                                        modal-classes="modal-dialog-centered modal-lg">
                                        <div class="card bg-secondary border-0 mb-0">
                                            <div class="card-body">
                                                <PageSpinner :onloader="onloader" />
                                                <form role="form">
                                                    <div class="form-group">
                                                        <label>Question</label>
                                                        <vue-editor id="ExamQuestionval" v-model="ExamQuestionval">
                                                        </vue-editor>
                                                    </div>
                                                    <div class="form-group">
                                                        <label>Answer Details</label>
                                                        <vue-editor id="AnswerDetailsval" v-model="AnswerDetailsval">
                                                        </vue-editor>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-8">
                                                            <div class="form-group">
                                                                <label>Option A</label>
                                                                <vue-editor id="OptionAval" v-model="OptionAval">
                                                                </vue-editor>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <base-checkbox class="mt-6 mb-4 ml-4"
                                                                onchange="checkcheck()" v-model="IsOptionAAnswerval">
                                                                Is A Answer
                                                            </base-checkbox>
                                                        </div>
                                                        <div class="col-md-8">
                                                            <div class="form-group">
                                                                <label>Option B</label>
                                                                <vue-editor id="OptionBval" v-model="OptionBval">
                                                                </vue-editor>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <base-checkbox class="mt-6 mb-6 ml-4"
                                                                onchange="checkcheck()" v-model="IsOptionBAnswerval">
                                                                Is B Answer
                                                            </base-checkbox>
                                                        </div>
                                                        <div class="col-md-8">
                                                            <div class="form-group">
                                                                <label>Option C</label>
                                                                <vue-editor id="OptionCval" v-model="OptionCval">
                                                                </vue-editor>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <base-checkbox class="mt-6 mb-6 ml-4"
                                                                onchange="checkcheck()" v-model="IsOptionCAnswerval">
                                                                Is C Answer
                                                            </base-checkbox>
                                                        </div>
                                                        <div class="col-md-8">
                                                            <div class="form-group">
                                                                <label>Option D</label>
                                                                <vue-editor id="OptionDval" v-model="OptionDval">
                                                                </vue-editor>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4">
                                                            <base-checkbox class="mt-6 mb-6 ml-4"
                                                                onchange="checkcheck()" v-model="IsOptionDAnswerval">
                                                                Is D Answer
                                                            </base-checkbox>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                        <template slot="footer">
                                            <base-button type="default" @click="modals.questionModal = false">Cancel
                                            </base-button>
                                            <base-button type="success" @click.prevent="SubmitExamPrep()">Submit
                                            </base-button>
                                        </template>
                                    </modal>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="form-inline">
                            <select v-model="ExamYearIdval" @change="GetExamQuestions()" class="form-control" :disabled="!yearItems">
                                <option value="0" v-if="!yearItems">⏳ Loading...</option>
                                <option value="0" v-else>- Select Year -</option>
                                <option v-for="item in yearItems" :key="item.examYearId" v-bind:value="item.examYearId">
                                    {{ item.examYear }}
                                </option>
                            </select>
                            <button v-if="ExamYearIdval" class="btn btn-success ml-3"
                                v-on:click="OpenNewquestionModal()">
                                <i class="fa fa-edit"></i> New
                            </button>
                        </div>
                        <div class="mt-2">
                            <list-skeleton v-if="!questionItems" :rows="3" />
                            <div v-else class="card bg-secondary my-2" v-for="(item, index) in questionItems"
                                :key="item.Id">
                                <div class="card-body">
                                    <span class=" badge badge-warning"> Qtn. {{ index + 1 }}</span>
                                    <div class="my-3" v-html="item.examQuestion">
                                    </div>
                                    <div class="m-3">
                                        <div class="row">
                                            <div class="col-lg-1">
                                                <span v-if="item.isOptionAAnswer" class="badge badge-success">A</span>
                                                <span v-else class="badge badge-dark">A</span>
                                            </div>

                                            <div class="col-lg-11" v-html="item.optionA"></div>

                                        </div>
                                        <div class="row">
                                            <div class="col-lg-1">
                                                <span v-if="item.isOptionBAnswer" class="badge badge-success">B</span>
                                                <span v-else class="badge badge-dark">B</span>
                                            </div>
                                            <div class="col-lg-11" v-html="item.optionB"></div>

                                        </div>
                                        <div class="row">
                                            <div class="col-lg-1">
                                                <span v-if="item.isOptionCAnswer" class="badge badge-success">C</span>
                                                <span v-else class="badge badge-dark">C</span>
                                            </div>
                                            <div class="col-lg-11" v-html="item.optionC"></div>

                                        </div>
                                        <div class="row">
                                            <div class="col-lg-1">
                                                <span v-if="item.isOptionDAnswer" class="badge badge-success">D</span>
                                                <span v-else class="badge badge-dark">D</span>
                                            </div>
                                            <div class="col-lg-11" v-html="item.optionD"></div>

                                        </div>
                                        <div class=" bg-translucent-secondary m-3 p-3">
                                            <b class=" text-success">Answer Details</b>
                                            <div v-html="item.answerDetails"></div>
                                        </div>
                                    </div>
                                    <div class=" card-footer text-center">
                                        <button class="btn btn-secondary btn-sm my-2" v-on:click="GetById(item)"><i
                                                class="fa fa-edit"></i>
                                            Edit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>

            <!-- End charts-->

        </div>

    </div>
</template>

<script>
import 'quill/dist/quill.snow.css'
import { VueEditor } from 'vue2-quill-editor'
import PageSpinner from "@/components/PageSpinner";
import ValidateAccessToken from "@/mixins/ValidateAccessToken.mixins";
import Alert from "@/mixins/Alert.mixins"
import katex from 'katex';
import 'katex/dist/katex.min.css';
window.katex = katex;
export default {
    name: 'ExamPrepQuestion',
    mixins: [ValidateAccessToken, Alert],
    components: {
        PageSpinner,
        VueEditor,
    },
    data() {
        return {
            accessDetails: null,
            ExamIdval: localStorage.getItem('ExamId') || '',
            ExamSubjectIdval: localStorage.getItem('ExamSubjectId') || '',
            ExamYearIdval: 0,
            ExamQuestionIdval: 0,
            ExamQuestionval: '',
            AnswerDetailsval: '',
            ImagePathval: '',
            OptionAIdval: 0,
            OptionBIdval: 0,
            OptionCIdval: 0,
            OptionDIdval: 0,
            OptionAval: '',
            IsOptionAAnswerval: false,
            OptionBval: '',
            IsOptionBAnswerval: false,
            OptionCval: '',
            IsOptionCAnswerval: false,
            OptionDval: '',
            IsOptionDAnswerval: false,
            questionItems: null,
            SubjectItems: null,
            yearItems: null,
            isModified: false,
            openform: false,
            onloader: 'none',
            modals: {
                questionModal: false
            }
        }
    },
    methods: {
        OpenNewquestionModal() {
            this.isModified = false;
            this.modals.questionModal = true
        },
        resetInput() {
            this.ExamQuestionIdval = 0;
            this.AnswerDetailsval = "";
            this.OptionAIdval = 0;
            this.OptionAval = "";
            this.IsOptionAAnswerval = false;
            this.OptionBIdval = 0;
            this.OptionBval = "";
            this.IsOptionBAnswerval = false;
            this.OptionCIdval = 0;
            this.OptionCval = "";
            this.IsOptionCAnswerval = false;
            this.OptionDIdval = 0;
            this.OptionDval = "";
            this.IsOptionDAnswerval = false;
        },
        checkcheck() {
            if (this.IsAnswerAval == true) {
                this.IsAnswerBval = false;
                this.IsAnswerCval = false;
                this.IsAnswerDval = false;
            }
            if (this.IsAnswerBval == true) {
                this.IsAnswerAval = false;
                this.IsAnswerCval = false;
                this.IsAnswerDval = false;
            }
            if (this.IsAnswerCval == true) {
                this.IsAnswerBval = false;
                this.IsAnswerAval = false;
                this.IsAnswerDval = false;
            }
            if (this.IsAnswerDval == true) {
                this.IsAnswerBval = false;
                this.IsAnswerCval = false;
                this.IsAnswerAval = false;
            }
        },
        GetById(item) {
            this.resetInput();
            this.ExamQuestionIdval = item.examQuestionId;
            this.ExamQuestionval = item.examQuestion;
            this.AnswerDetailsval = item.answerDetails;
            this.OptionAIdval = item.optionAId;
            this.OptionAval = item.optionA;
            this.IsOptionAAnswerval = item.isOptionAAnswer;
            this.OptionBIdval = item.optionBId;
            this.OptionBval = item.optionB;
            this.IsOptionBAnswerval = item.isOptionBAnswer;
            this.OptionCIdval = item.optionCId;
            this.OptionCval = item.optionC;
            this.IsOptionCAnswerval = item.isOptionCAnswer;
            this.OptionDIdval = item.optionDId;
            this.OptionDval = item.optionD;
            this.IsOptionDAnswerval = item.isOptionDAnswer;
            this.isModified = true;
            this.modals.questionModal = true
        },
        SubmitExamPrep() {
            let ExamQuestionId = this.ExamQuestionIdval;
            let ExamSubjectId = this.ExamSubjectIdval;
            let ExamYearId = this.ExamYearIdval;
            let ExamQuestion = this.ExamQuestionval;
            let AnswerDetails = this.AnswerDetailsval;
            let OptionAId = this.OptionAIdval;
            let OptionA = this.OptionAval;
            let IsOptionAAnswer = this.IsOptionAAnswerval;
            let OptionBId = this.OptionBIdval;
            let OptionB = this.OptionBval;
            let IsOptionBAnswer = this.IsOptionBAnswerval;
            let OptionCId = this.OptionCIdval;
            let OptionC = this.OptionCval;
            let IsOptionCAnswer = this.IsOptionCAnswerval;
            let OptionDId = this.OptionDIdval;
            let OptionD = this.OptionDval;
            let IsOptionDAnswer = this.IsOptionDAnswerval;

            if (ExamSubjectId > 0) {
                let userdata = {};
                this.onloader = "flex";
                let operationVal = "";
                if (this.isModified == false) {
                    operationVal = "ExamPrep/CreateExamQuestion";
                    userdata = {
                        ExamSubjectId,
                        ExamYearId,
                        ExamQuestion,
                        AnswerDetails,
                        OptionA,
                        IsOptionAAnswer,
                        OptionB,
                        IsOptionBAnswer,
                        OptionC,
                        IsOptionCAnswer,
                        OptionD,
                        IsOptionDAnswer
                    }
                } else {
                    operationVal = "ExamPrep/UpdateExamQuestion";
                    userdata = {
                        ExamQuestionId,
                        ExamSubjectId,
                        ExamYearId,
                        ExamQuestion,
                        AnswerDetails,
                        OptionAId,
                        OptionA,
                        IsOptionAAnswer,
                        OptionBId,
                        OptionB,
                        IsOptionBAnswer,
                        OptionCId,
                        OptionC,
                        IsOptionCAnswer,
                        OptionDId,
                        OptionD,
                        IsOptionDAnswer
                    }
                }
                this.$store
                    .dispatch(operationVal, userdata)
                    .then((resp) => {
                        this.onloader = "none";
                        if (resp.responseCode == '00') {
                            this.GetExamQuestions();
                            this.resetInput();
                            this.modals.questionModal = false;
                            this.ShowAlertSuccess('Submitted successfully', '');
                        } else {
                            this.ShowAlertError(resp.responseMessage, '');
                        }

                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            } else {
                this.ShowAlertError('Select Subject', '');
            }
        },
        GetExamQuestions() {
            let ExamSubjectId = this.ExamSubjectIdval;
            let ExamYearId = this.ExamYearIdval;
            if (ExamYearId > 0) {
                let userdata = {
                    ExamSubjectId,
                    ExamYearId
                }
                this.onloader = 'flex'
                this.$store.dispatch('ExamPrep/GetExamQuestions', userdata)
                    .then((resp) => {
                        this.questionItems = resp.data;
                        this.onloader = 'none'
                    })
                    .catch(err => {
                        this.onloader = 'none'
                        this.ShowAlertError(err.response.data, '');
                    })
            } else {
                this.ShowAlertError('Select Year', '');
            }

        },
        GetExamSubjectById() {
            this.onloader = 'flex'
            let ExamSubjectId = this.ExamSubjectIdval;
            this.$store.dispatch('ExamPrep/GetExamSubjectById', ExamSubjectId)
                .then(resp => {
                    this.SubjectItems = resp.data;
                    this.GetExamYears();
                })
                .catch(err => {
                    this.onloader = 'none'
                    this.ShowAlertError(err.response.data, '');
                })
        },
        GetExamYears() {
            this.$store
                .dispatch("ExamPrep/GetExamYears")
                .then((resp) => {
                    this.yearItems = resp.data;
                    this.onloader = "none";
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
    },
    mounted() {
        const userDetails = this.accessDetails = this.$store.getters['auth/_user'];
        if (
            userDetails.isSuperAdmin == true ||
            userDetails.isAdmin == true ||
            userDetails.isSupportAdmin == true
        ) {
            this.GetExamSubjectById();
        } else {

            this.$store.dispatch('Auth/logout')
            this.$router.push('/login')
        }

    }
};
</script>
